import { put, select, takeLatest } from "redux-saga/effects";
import { loginWithPassword } from "../../lib/services";
import { handleError } from "../actions/loginactioncreators";
import {
    loginSetFlowStageWatcher, handleChallengeWatcher, setMfaTypeSetupComplete, mfaSetupComplete
} from "../actions/loginactioncreators";
import getDeviceData from "../helpers/getDeviceData";
import getUsername from "../helpers/getUsername";
import { normalizePayload } from "../helpers/normalizePayload";
import getClientId from "../helpers/getClientId";
import { navigateToAuthorize } from "../helpers/navigators";
import getLocale from "../helpers/getLocale";
import getUserPoolId from "../helpers/getUserPoolId";
import getMfa from "../helpers/getMfa";
import flowStages from "../../flowStages";
import actiontypes from "../actions/actiontypes";
import getAccountNumber from "../helpers/getAccountNumber";

// let authHelper;

// TODO: COR-6288
// TODO: I think there are only 2 legit uses for this flow:  MFA set up (post auth) and user with no email.  This whole thing needs to 
// TODO: be refactored, but it was easier to get it working first as is.
function* legacyLoginAsync(action) {
    try {
        const AmazonCognitoAdvancedSecurityData = window["AmazonCognitoAdvancedSecurityData"];
        const username = yield select(getUsername);
        const clientId = yield select(getClientId);
        const userPoolId = yield select(getUserPoolId);
        const accountNumber = yield select(getAccountNumber);
        const encodedData = AmazonCognitoAdvancedSecurityData.getData(username, userPoolId, clientId);
        let payload = normalizePayload(action.payload);
        payload.userContextData = encodedData;
        const deviceData = yield select(getDeviceData, username);
        const currentTime = new Date().getTime();
        if (deviceData.deviceKey && deviceData.expires > currentTime) {
            payload.deviceKey = deviceData.deviceKey;
        }
        if (clientId) {
            payload.client_id = clientId;
        }
        if (accountNumber) {
            payload.accountNumber = accountNumber;
        }
        const locale = yield select(getLocale);
        const options = {
            headers: {
                "Accept-Language": locale,
            }
        };

        let { data } = yield loginWithPassword(payload, options);

        if (data.flowStage === flowStages.CHALLENGE) {
            // } else if (data.challenge.challengeName === challenges.DEVICE_PASSWORD_VERIFIER) {
            //   if (!authHelper) {
            //     authHelper = new AuthHelper(deviceData.deviceGroupKey)
            //   }
            //   let params = {
            //     username: data.challenge.challengeParameters.USER_ID_FOR_SRP,
            //     deviceGroupKey: deviceData.deviceGroupKey,
            //     deviceKey: deviceData.deviceKey,
            //     devicePassword: deviceData.devicePassword,
            //     serverBValue: new BigInteger(data.challenge.challengeParameters.SRP_B, 16),
            //     salt: new BigInteger(data.challenge.challengeParameters.SALT, 16),
            //     secretBlock: data.challenge.challengeParameters.SECRET_BLOCK
            //   };
            //   const challengeResponses = yield call(
            //     [authHelper, "getPasswordAuthenticationKey"], params
            //   );
            //   if (challengeResponses) {
            //     yield put(loginWatcher({
            //       flowStage: flowStages.CHALLENGE,
            //       challengeResponse: {
            //         session: data.session,
            //         challengeName: data.challenge.challengeName,
            //         challengeParameters: challengeResponses
            //       }
            //     }));
            //   }
            //} else {
            yield put(handleChallengeWatcher(data));
        }
        else if (data.flowStage === flowStages.CHALLENGE_MFA_SETUP) {
            if (data.challenge && data.challenge.step === "MFA_SETUP_COMPLETE") {
                if (data.challenge.challengeParameters?.mfaType) {
                    const mfaType = data.challenge.challengeParameters.mfaType;
                    yield put(setMfaTypeSetupComplete(mfaType));
                    yield put(mfaSetupComplete());
                }
                else yield put(handleChallengeWatcher(data));
            }
            // } else if (data.challenge && data.challenge.challengeName === challenges.DEVICE_SRP_AUTH) {
            //   if (!authHelper) {
            //     authHelper = new AuthHelper(deviceData.deviceGroupKey)
            //   }
            //   const srpA = yield call([authHelper, "getLargeAValue"]);
            //   if (srpA) {
            //     yield put(loginWatcher({
            //       flowStage: "CHALLENGE",
            //       challengeResponse: {
            //         session: data.session,
            //         challengeName: data.challenge.challengeName,
            //         challengeParameters: {
            //           USERNAME: data.challenge.challengeParameters.USER_ID_FOR_SRP,
            //           DEVICE_KEY: deviceData.deviceKey,
            //           SRP_A: srpA.toString(16)
            //         }
            //       }
            //     }));
            //   }
            else {
                const mfa = yield select(getMfa);
                if (mfa?.sms?.enabled || mfa?.email?.enabled) {
                    // update the challenge but keep the flow stage because we are in the same component
                    data.keepFlowStage = true;
                }
                
                yield put(handleChallengeWatcher(data));
            }
        }
        else if (data.flowStage === flowStages.AUTHENTICATED || data.flowStage === flowStages.AUTHENTICATED_FIRST_TIME) {
            // if (data.deviceKey) {
            //   const today = new Date();
            //   const expireDate = new Date().setDate(today.getDate() + 30);
            //   const username = yield select(getUsername);
            //   yield put(setDeviceData(username.trim().toLowerCase(), data.deviceKey, data.deviceGroupKey, data.devicePassword, expireDate));
            // }
            if (data.flowStage === flowStages.AUTHENTICATED) {
                navigateToAuthorize();
            } else {
                yield put(loginSetFlowStageWatcher(data));
            }
        }
        else {
            throw new Error(`invalid flowStage ${data.flowStage}`);
        }
    } catch (error) {
        yield put(handleError(error));
    }
}

export function* watchLegacyLoginAsync() {
    yield takeLatest(actiontypes.USER_LOGIN_LEGACY, legacyLoginAsync);
}